/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { CLEAR_CREEK_PERMIT_TYPES } from '../../utils/utils';

export default class ClearCreekQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHighwayVehicle: null,
            isNotHighwayVehicle: null,
            isEnteringACEC: null,
            isNotEnteringACEC: null,
            isEnteringATVUTV: null,
            isNotEnteringATVUTV: null,
        };

        this.handleIsHighwayVehicleChange = this.handleIsHighwayVehicleChange.bind(this);
        this.handleIsEnteringACECChange = this.handleIsEnteringACECChange.bind(this);
        this.handleIsEnteringATVUTVChange = this.handleIsEnteringATVUTVChange.bind(this);
    }

    changeSelection() {
        const { isHighwayVehicle, isEnteringACEC, isEnteringATVUTV } = this.state;

        this.props.permitSelectionChange({
            [CLEAR_CREEK_PERMIT_TYPES.CK_VEHICLE_PERMIT]: isHighwayVehicle,
            [CLEAR_CREEK_PERMIT_TYPES.ACEC_PERMIT]: isEnteringACEC,
            [CLEAR_CREEK_PERMIT_TYPES.ATV_PERMIT]: isEnteringATVUTV,
        });
    }

    handleIsHighwayVehicleChange({ target }) {
        const { value } = target;
        this.setState(
            {
                isHighwayVehicle: value === 'yes',
                isNotHighwayVehicle: value === 'no',
            },
            () => this.changeSelection()
        );
    }

    handleIsEnteringACECChange({ target }) {
        const { value } = target;
        this.setState(
            {
                isEnteringACEC: value === 'yes',
                isNotEnteringACEC: value === 'no',
            },
            () => this.changeSelection()
        );
    }

    handleIsEnteringATVUTVChange({ target }) {
        const { value } = target;
        this.setState(
            {
                isEnteringATVUTV: value === 'yes',
                isNotEnteringATVUTV: value === 'no',
            },
            () => this.changeSelection()
        );
    }

    render() {
        const {
            isHighwayVehicle,
            isNotHighwayVehicle,
            isEnteringACEC,
            isNotEnteringACEC,
            isEnteringATVUTV,
            isNotEnteringATVUTV,
        } = this.state;

        return (
            <ul className="permit-question-list">
                <li>
                    <fieldset className="permit-question-wrap">
                        <legend className="permit-question">
                            <span className="permit-question-number">1</span>
                            Will you be entering the Clear Creek Management Area in a
                            highway licensed vehicle?
                        </legend>
                        <div className="rec-form-inline-item-wrap">
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="entering-highway-vehicle-yes"
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id="entering-highway-vehicle-yes"
                                        name="entering-highway-vehicle-prompt"
                                        radioGroup="entering-highway-vehicle-group"
                                        value="yes"
                                        checked={isHighwayVehicle}
                                        onChange={this.handleIsHighwayVehicleChange}
                                    />
                                    <span className="rec-input-radio" />
                                    Yes
                                </label>
                            </div>
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="entering-highway-vehicle-no"
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id="entering-highway-vehicle-no"
                                        name="entering-highway-vehicle-prompt"
                                        radioGroup="entering-highway-vehicle-group"
                                        value="no"
                                        checked={isNotHighwayVehicle}
                                        onChange={this.handleIsHighwayVehicleChange}
                                    />
                                    <span className="rec-input-radio" />
                                    No
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </li>
                <li>
                    <fieldset className="permit-question-wrap">
                        <legend className="permit-question">
                            <span className="permit-question-number">2</span>
                            Will you be entering the Serpentine Area (ACEC), including the
                            route to Joaquin Ridge?
                        </legend>
                        <div className="rec-form-inline-item-wrap">
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="entering-acec-yes"
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id="entering-acec-yes"
                                        name="entering-acec-prompt"
                                        radioGroup="entering-acec-group"
                                        value="yes"
                                        checked={isEnteringACEC}
                                        onChange={this.handleIsEnteringACECChange}
                                    />
                                    <span className="rec-input-radio" />
                                    Yes
                                </label>
                            </div>
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="entering-acec-no"
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id="entering-acec-no"
                                        name="entering-acec-prompt"
                                        radioGroup="entering-acec-group"
                                        value="no"
                                        checked={isNotEnteringACEC}
                                        onChange={this.handleIsEnteringACECChange}
                                    />
                                    <span className="rec-input-radio" />
                                    No
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </li>
                <li>
                    <fieldset className="permit-question-wrap">
                        <legend className="permit-question">
                            <span className="permit-question-number">3</span>
                            Will you be entering Condon Peak&#39;s trail network and/or
                            the Condon Peak Campground with a four-wheeled, All-Terrain
                            Vehicle (ATV) or Utility-Terrain Vehicle (UTV)?
                        </legend>
                        <div className="rec-form-inline-item-wrap">
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="entering-atv-utv-yes"
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id="entering-atv-utv-yes"
                                        name="entering-atv-utv-prompt"
                                        radioGroup="entering-atv-utv-group"
                                        value="yes"
                                        checked={isEnteringATVUTV}
                                        onChange={this.handleIsEnteringATVUTVChange}
                                    />
                                    <span className="rec-input-radio" />
                                    Yes
                                </label>
                            </div>
                            <div className="rec-form-inline-item">
                                <label
                                    htmlFor="entering-atv-utv-no"
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id="entering-atv-utv-no"
                                        name="entering-atv-utv-prompt"
                                        radioGroup="entering-atv-utv-group"
                                        value="no"
                                        checked={isNotEnteringATVUTV}
                                        onChange={this.handleIsEnteringATVUTVChange}
                                    />
                                    <span className="rec-input-radio" />
                                    No
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </li>
            </ul>
        );
    }
}

ClearCreekQuestions.propTypes = {
    permitSelectionChange: PropTypes.func.isRequired,
};
